import React from 'react';
import { color } from './color.js';
import pages from '../screens/all-pages';
import { Icon } from './icon.js';
import { FaCog } from 'react-icons/fa';

export const ROUTE_LOGIN = 'https://central.zetta-system.com';
export const ROUTE_LOGIN_MANUAL = '/account/login';
export const ROUTE_HANDLE = '/account/handle';

export const KEY_ROUTE_MAIN = '@ROUTES/ROUTE_MAIN';
export const KEY_ROUTE_HOME = '@ROUTES/ROUTE_HOME';
export const KEY_ROUTE_REGISTRATION_LIST = '@ROUTES/ROUTE_REGISTRATION_LIST';
export const KEY_ROUTE_REGISTRATION_ADD = '@ROUTES/ROUTE_REGISTRATION_ADD';
export const KEY_ROUTE_REGISTRATION_VIEW = '@ROUTES/ROUTE_REGISTRATION_VIEW';
export const KEY_ROUTE_REGISTRATION_EDIT = '@ROUTES/ROUTE_REGISTRATION_EDIT';

//claim
export const KEY_ROUTE_CLIAM_LIST = '@ROUTES/ROUTE_CLIAM_LIST';
export const KEY_ROUTE_CLAIM_ADD = '@ROUTES/ROUTE_CLAIM_ADD';
export const KEY_ROUTE_CLAIM_VIEW = '@ROUTES/ROUTE_CLAIM_VIEW';
export const KEY_ROUTE_CLAIM_EDIT = '@ROUTES/ROUTE_CLAIM_EDIT';

//Scan Delivery
export const KEY_ROUTE_SCAN_DELIVERY = '@ROUTES/ROUTE_SCAN_DELIVERY';

//User Info
export const KEY_ROUTE_USER_INFO = '@ROUTE/ROUTE_USER_INFO';

//Product Warranty
export const KEY_ROUTE_PRODUCT_WARRANTY = '@ROUTE/ROUTE_PRODUCT_WARRANTY';
export const KEY_ROUTE_COLOR_QR = '@ROUTES/ROUTE_COLOR_QR';
export const KEY_ROUTE_PRODUCT = '@ROUTES/ROUTE_PRODUCT';

//Report
export const KEY_ROUTE_REPORT_ALL = '@ROUTES/ROUTE_REPORT_ALL';
export const KEY_ROUTE_REPORT = '@ROUTES/ROUTE_REPORT';
export const KEY_ROUTE_REPORT_CLAIM = '@ROUTES/ROUTE_REPORT_CLAIM';
export const KEY_ROUTE_REPORT_WARRANTY = '@ROUTES/ROUTE_REPORT_WARRANTY';

//User Permisson
export const KEY_ROUTE_USER_PERMISSION = '@ROUTE/ROUTE_USER_PERMISSION';

//Gen QR Code
export const KEY_ROUTE_GEN_QR_CODE = '@ROUTES/ROUTE_GEN_QR_CODE';

function renderStyle(comp) {
  return <div style={{ marginRight: '1px', color: color.yellow_why }}>{comp}</div>;
}

export const ROUTES_PATH = {
  ROUTE_MAIN: {
    KEY: KEY_ROUTE_MAIN,
    PATH: '/',
    LABEL: 'หน้าหลัก',
    COMPONENT: pages.MainPage,
  },
  ROUTE_HOME: {
    KEY: KEY_ROUTE_HOME,
    PATH: '/home',
    LABEL: 'หน้าหลัก',
    CODE: 'PE001',
  },
  ROUTE_REGISTRATION_LIST: {
    KEY: KEY_ROUTE_REGISTRATION_LIST,
    PATH: '/warranty',
    ICON: renderStyle(<Icon.Registered />),
    LABEL: 'รายการลงทะเบียน',
    CODE: 'PE101',
    COMPONENT: pages.RegistrationList,
  },
  ROUTE_REGISTRATION_ADD: {
    KEY: KEY_ROUTE_REGISTRATION_ADD,
    PATH: '/warranty-add',
    LABEL: 'ลงทะเบียนสินค้า',
    CODE: 'PE111',
    COMPONENT: pages.RegistrationAdd,
  },
  ROUTE_REGISTRATION_VIEW: {
    KEY: KEY_ROUTE_REGISTRATION_VIEW,
    PATH: '/warranty-view',
    LABEL: 'ดูข้อมูลลงทะเบียน',
    CODE: 'PE113',
    COMPONENT: pages.RegistrationView,
  },
  ROUTE_REGISTRATION_EDIT: {
    KEY: KEY_ROUTE_REGISTRATION_EDIT,
    PATH: '/warranty-edit',
    LABEL: 'แก้ไขข้อมูลลงทะเบียน',
    CODE: 'PE113',
    COMPONENT: pages.RegistrationEdit,
  },
  ROUTE_CLIAM_LIST: {
    KEY: KEY_ROUTE_CLIAM_LIST,
    PATH: '/claim',
    LABEL: 'เคลมสินค้า',
    ICON: renderStyle(<Icon.FileSearch />),
    CODE: 'PE201',
    COMPONENT: pages.ClaimList,
  },
  ROUTE_CLAIM_ADD: {
    KEY: KEY_ROUTE_CLAIM_ADD,
    PATH: '/claim-add',
    LABEL: 'ยื่นเรื่องเคลม',
    CODE: 'PE211',
    COMPONENT: pages.ClaimAdd,
  },
  ROUTE_CLAIM_VIEW: {
    KEY: KEY_ROUTE_CLAIM_VIEW,
    PATH: '/claim-view',
    LABEL: 'ดูการเคลมสินค้า',
    CODE: 'PE210',
    COMPONENT: pages.ClaimView,
  },
  ROUTE_CLAIM_EDIT: {
    KEY: KEY_ROUTE_CLAIM_EDIT,
    PATH: '/claim-edit',
    LABEL: 'แก้ไขเคลมสินค้า',
    CODE: 'PE212',
    COMPONENT: pages.ClaimEdit,
  },
  //Scan Delivery
  ROUTE_SCAN_DELIVERY: {
    KEY: KEY_ROUTE_SCAN_DELIVERY,
    ICON: renderStyle(<Icon.Qrcode />),
    PATH: '/scan-delivery',
    LABEL: 'ยิงจ่ายพัสดุ',
    CODE: 'PE301',
    COMPONENT: pages.ScanDelivery,
  },
  // User Info
  ROUTE_USER_INFO: {
    KEY: KEY_ROUTE_USER_INFO,
    ICON: renderStyle(<Icon.Users />),
    PATH: '/user',
    LABEL: 'ข้อมูลลูกค้า',
    CODE: 'PE401',
    COMPONENT: pages.UserInfo,
  },
  // Product Warranty
  ROUTE_PRODUCT: {
    KEY: KEY_ROUTE_PRODUCT,
    ICON: renderStyle(<Icon.FormExample />),
    PATH: '/product-warranty',
    LABEL: 'สินค้ารับประกัน',
    CODE: 'PE504',
    COMPONENT: pages.ProductWarranty,
  },
  // Color QR
  ROUTE_COLOR_QR: {
    KEY: KEY_ROUTE_COLOR_QR,
    ICON: renderStyle(<Icon.Ticket />),
    PATH: '/color-qr',
    LABEL: 'สี QR',
    CODE: 'PE501',
    COMPONENT: pages.ColorQr,
  },
  // Report
  ROUTE_REPORT: {
    KEY: KEY_ROUTE_REPORT,
    ICON: renderStyle(<Icon.Ticket />),
    PATH: '/report',
    LABEL: 'รายงานประวัติการเคลม',
    CODE: 'PE601',
    COMPONENT: pages.ReportPage,
  },
  ROUTE_REPORT_CLAIM: {
    KEY: KEY_ROUTE_REPORT_CLAIM,
    ICON: renderStyle(<Icon.Ticket />),
    PATH: '/report-claim',
    LABEL: 'รายงานเปลี่ยนสินค้าข้ามรุ่น',
    CODE: 'PE602',
    COMPONENT: pages.ReportClaim,
  },
  ROUTE_REPORT_WARRANTY: {
    KEY: KEY_ROUTE_REPORT_WARRANTY,
    ICON: renderStyle(<Icon.Ticket />),
    PATH: '/report-warranty',
    LABEL: 'หน้ารายงานประวัติลงทะเบียน',
    CODE: 'PE603',
    COMPONENT: pages.ReportWarranty,
  },
  // User Permission
  ROUTE_USER_PERMISSION: {
    KEY: KEY_ROUTE_USER_PERMISSION,
    ICON: renderStyle(<FaCog />),
    PATH: '/manage-permission',
    LABEL: 'ปรับสิทธิ์เมนู',
    CODE: 'PE701',
    COMPONENT: pages.UserPermission,
  },
  //Gen QR Code
  ROUTE_GEN_QR_CODE: {
    KEY: KEY_ROUTE_GEN_QR_CODE,
    ICON: renderStyle(<Icon.Qrcode />),
    PATH: '/gen-qr-code',
    LABEL: 'สร้าง QR Code',
    CODE: 'PE801',
    COMPONENT: pages.GenQrCode,
  },
};

function getKeyLowerCase(obj) {
  return Object.fromEntries(Object.entries(obj).map(([k, v]) => [k.toLowerCase(), v]));
}

export const ROUTES_MENU = [
  getKeyLowerCase(ROUTES_PATH.ROUTE_REGISTRATION_LIST),
  getKeyLowerCase(ROUTES_PATH.ROUTE_CLIAM_LIST),
  getKeyLowerCase(ROUTES_PATH.ROUTE_SCAN_DELIVERY),
  getKeyLowerCase(ROUTES_PATH.ROUTE_USER_INFO),
  {
    key: KEY_ROUTE_PRODUCT_WARRANTY,
    icon: renderStyle(<Icon.FormExample />),
    label: 'สินค้ารับประกัน',
    children: [
      getKeyLowerCase(ROUTES_PATH.ROUTE_COLOR_QR),
      getKeyLowerCase(ROUTES_PATH.ROUTE_PRODUCT),
    ],
  },
  {
    key: KEY_ROUTE_REPORT_ALL,
    icon: renderStyle(<Icon.FormExample />),
    label: 'รายงาน',
    children: [
      getKeyLowerCase(ROUTES_PATH.ROUTE_REPORT_WARRANTY),
      getKeyLowerCase(ROUTES_PATH.ROUTE_REPORT),
      getKeyLowerCase(ROUTES_PATH.ROUTE_REPORT_CLAIM),
    ],
  },
  getKeyLowerCase(ROUTES_PATH.ROUTE_GEN_QR_CODE),
  getKeyLowerCase(ROUTES_PATH.ROUTE_USER_PERMISSION),
];
